/**
 * Converts section value to dimensions string format expected by the API
 * @param sectionValue - Section value (e.g., "4x4", "4.5x8")
 * @returns Dimensions string in "width,height" format or original value if conversion fails
 */
export const convertSectionToDimensionsString = (
  sectionValue: string,
): string => {
  if (!sectionValue || sectionValue === "Unknown") {
    return "";
  }

  // Convert "4x4" to "4,4" format expected by proxy
  const dimensionMatch = sectionValue.match(/^([\d.]+)x([\d.]+)$/);
  if (dimensionMatch) {
    return `${dimensionMatch[1]},${dimensionMatch[2]}`;
  }

  // Fallback to original value if no match
  return sectionValue;
};

/**
 * Determines if billets are for sale based on destination selection
 * @param destinationValue - Selected destination value (null=Unknown, "FALSE"=Roanoke, "TRUE"=Customer)
 * @returns True if for sale (Customer), false if not (Roanoke or Unknown)
 */
export const determineIsForSale = (
  destinationValue: string | null,
): boolean => {
  // "TRUE" represents Customer (for sale)
  // "FALSE" represents Roanoke (not for sale)
  // null represents Unknown (defaults to not for sale)
  return destinationValue === "TRUE";
};
